module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "imagel"
  }, [_c('a', {
    attrs: {
      "id": "ch006"
    }
  }), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0020-01.jpg",
      "width": "450px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“CAPTAIN JEAN-LUC PICARD (played by Patrick Stewart): Picard deserves the description ‘distinguished.’ A born explorer and superbly experienced starship commander, he served on an incredible 22-year voyage as captain of the legendary deep space charting vessel, the "), _c('em', [_vm._v("U.S.S. Stargazer")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Born in Paris, France, Picard betrays a Gallic accent only when deep emotions are triggered. Quite often, however, there’s a touch of French phrasing in his speech. He is in prime physical condition. Definitely a ‘romantic,’ he sincerely believes in concepts like honor and duty, although on issues that affect the safety of his crew and starship, he can be completely pragmatic and tough as hell.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Picard demands absolute authority in his role as starship captain. On the other hand, he has learned that there are many more times at which a leader needs advice, counsel, and even critical comment from his subordinates. He invites this and expects his crew to know when the situation does or does not permit it. Picard’s vast experience has left him capable of arranging which one he needs—when he needs it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He enjoys the privileges that go with his rank and vessel—also the eccentricities permitted. He knows that a certain amount of selfishness is healthy and necessary to the captain of a starship this vast, engaged in missions of this importance and under so much emotional pressure. He does not hesitate to make his prejudices known to his crew, an example of which is his insistence that he does not like children….”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("—from the "), _c('em', [_vm._v("Star Trek: The Next Generation")]), _vm._v(" writers’/directors’ guide ’88–89, second-season revision")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0021-01.jpg",
      "width": "450px"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0fb8eebe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch006.vue
// module id = 90
// module chunks = 0